import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';
import swal from 'sweetalert'
function formatDate(dateString) {
    const date = new Date(dateString);
    
    // Array of month names (short form)
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    
    // Extract day, month, and year
    const day = String(date.getUTCDate()).padStart(2, "0"); // Use getUTCDate for UTC time
    const month = monthNames[date.getUTCMonth()]; // Use getUTCMonth for UTC time
    const year = date.getUTCFullYear(); // Use getUTCFullYear for UTC time
    
    // Return formatted string
    return `${day} ${month} ${year}`;
  }
const ReportsTable = ({jobsData}) => {
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})

      const handleDelete = async(id)=>{
        
          swal({
            title: "Are you sure you want to delete this report?",
            text: "This action cannot be undone!",
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
          }).then( async (willDelete) => {
            if (willDelete) {
              let headersList = {
                "Accept": "*/*",
                "Content-Type": "application/json"
               }
               let response = await fetch(`${API_URL}/api/reports/delete/${id}`, { 
                 method: "DELETE",
                 headers: headersList
               });
               let data = await response.json();
               if(data.message=="Report deleted successfully"){
                  window.location.reload();
               }
            }
          });
      
       
      }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'report_type' },
            { data: 'affiliate.business_name' },
            { data: 'createdAt' , render:function(data,type,row){
                return `${formatDate(data)}`
            } },
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
               
                <a href="${row.report_url}" class="btn btn-secondary" data-id="${row.id}"><i class="ph ph-download"></i></a>
                <button class="btn btn-secondary delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i></button>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
       
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);


    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Reports</h5>
            <div class="col-md-6 text-end">
           
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    
                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Report For</th>
                <th scope="col">Created By</th>
             
                <th scope="col">Created Date</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default ReportsTable